import { getObjectKeysAsObject } from "@checkout/helpers";
import {
  CardPaymentActions,
  CartActions,
  FlightExchangeActions,
  FlightPassengerActionsV2,
  ReviewActions,
} from "@checkout/states";
import { commonCheckoutActions } from "@hsbc/portal";

export const Actions = {
  ...CardPaymentActions,
  ...CartActions,
  ...FlightExchangeActions,
  ...FlightPassengerActionsV2,
  ...ReviewActions,
  ...commonCheckoutActions,
};

export const ActionTypes = getObjectKeysAsObject(Actions);
